import { KatalComponent } from '../../shared/base';

/**
 * @component {kat-progressbar} KatalProgressbar Used to indicate progress of an operation such as a download
 * @status Production
 * @theme flo
 * @example WithoutLabel {"value": 50,"variant":"primary"}
 * @example WithLabel {"value": 20, "label": "Loading . . .","variant":"primary"}
 * @example HistogramBar {"value": 77,"variant":"secondary"}
 */
export class ColombiaProgressbar extends KatalComponent {
  static get observedAttributes() {
    return ['value', 'label', 'variant'];
  }

  constructor() {
    super(ColombiaProgressbar.observedAttributes);
    this.initialRender = true;
  }

  connectedCallback() {
    super.connectedCallback();
    this.render();
    this.initialRender = false;
  }

  /**
   * @param {string} value This is the percentage complete of the operation.  Accepts 0-100
   */
  get value() {
    const val = this.getAttribute('value') || '';
    return this.normalizeProgressValue(val);
  }

  set value(value) {
    this.setAttribute('value', value);
  }

  /**
   * @param {string} label This is the text to display in the progress bar.  If attribute is missing the current value will be displayed.
   */
  get label() {
    return this.getAttribute('label');
  }

  set label(value) {
    this.setAttribute('label', value);
  }

  /**
   * @classprop {enum} variant This is the mode for the bar - Primary is default
   * @enum {value} primary Primary - Default
   * @enum {value} secondary Secondary
   */
  get variant() {
    return this.getAttribute('variant') || 'primary';
  }

  set variant(variant) {
    this.setAttribute('variant', variant);
  }

  normalizeProgressValue(value) {
    let progress = parseInt(value);
    if (!progress) {
      progress = 0;
    }

    if (progress > 100) {
      progress = 100;
    }
    return progress;
  }

  render() {
    const progress = this.value;
    const label = this.label;

    if (!this._progressLabel) {
      this._progressLabel = document.createElement('div');
      this._progressLabel.classList.add('kat-progress-bar-label');
      this.appendChild(this._progressLabel);
    }

    if (!this._progressOuterContainer) {
      this._progressOuterContainer = document.createElement('div');
      this._progressOuterContainer.classList.add('kat-progress-bar-container');
      this.appendChild(this._progressOuterContainer);
    }

    if (!this._progressContainer) {
      this._progressContainer = document.createElement('div');
      this._progressContainer.classList.add('kat-progress-bar');
      this._progressOuterContainer.appendChild(this._progressContainer);
    }

    if (!this._progressValue) {
      this._progressValue = document.createElement('span');
      this._progressValue.classList.add('kat-progress-bar-value');
      this.appendChild(this._progressValue);
    }

    this._progressContainer.style.width = `${progress}%`;
    this._progressLabel.innerText = label;
    this._progressValue.innerText = `${progress}%`;
  }

  // Respond to attribute changes.
  attributeChangedCallback() {
    if (!this.initialRender) {
      this.render();
    }
  }
}

KatalComponent.register('kat-progressbar', ColombiaProgressbar);
